import React from 'react'

interface PaymentFormProps {
  result: {
    [name: string]: any
    variables?: { [name: string]: string }
  }
  status: number
}

export default class PaymentForm extends React.Component<PaymentFormProps> {

  form: HTMLFormElement

  componentDidMount() {
    this.form.submit() 
  }

  renderVariables = (variables: { [name: string]: string }): React.ReactNode => (
    Object.entries(variables).map(([name, value]) => (
      <input type="hidden" name={'variables[' + name + ']'} value={value} />
    ))
  )

  render() {
    const { result, status } = this.props
    if(status !== 200) return <div>Payment error</div>

    return (
      <form
        ref={ref => this.form = ref}
        onLoad={event => { event.currentTarget.submit() }}
        method="POST"
        action="https://payment.quickpay.net"
      >
        {result && Object.entries(result).map(([name, value]) => (
          name === 'variables'
            ? this.renderVariables(value)
            : <input type="hidden" name={name} value={value} />
        ))}
      </form>
    )
  }

}
